import { render, staticRenderFns } from "./BatchUpdate.vue?vue&type=template&id=04579834&scoped=true"
import script from "./BatchUpdate.vue?vue&type=script&lang=js"
export * from "./BatchUpdate.vue?vue&type=script&lang=js"
import style0 from "./BatchUpdate.vue?vue&type=style&index=0&id=04579834&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04579834",
  null
  
)

export default component.exports